import React, {useEffect, useState} from 'react';
import {useList} from 'react-use';
import lodash from 'lodash';
import Checkbox from "../../../../../components/checkbox";

import {Collapse} from 'react-collapse';

function HittingProperty(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [listHitting, listHittingHelper] = useList([
        {
            value: 1,
            name: 'ゴロ',
            checked: false,
        },
        {
            value: 3,
            name: 'ライナー',
            checked: false,
        },
        {
            value: 2,
            name: 'フライ',
            checked: false,
        },
    ]);

    useEffect(() => {
        if(selected.length === 0) return;
        selected.map(item => {
            const index = listHitting.findIndex(i => i.value === item);
            listHitting[index].checked = true;
        })
    },[selected])
    useEffect(() => {
        props.onChange(lodash.map(lodash.filter(listHitting, ['checked', true]), 'value'));
    },[listHitting]);

    const onChange = (item, index) => {
        listHittingHelper.updateAt(index, {...item,checked: !item.checked})
    }

    return (
        <div className='group-filter-item'>
           <div className={'open-collapse'}>
               <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                   <h4>打球性質</h4>
                   <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
               </div>
               <Collapse isOpened={isOpened}>
                   <div className='d-flex-align-center' style={{ display: "flex"}}>
                       {listHitting.map((item, index) => {
                           return <div key={item.value} className={'search-main-advanced-checkbox'}>
                               <label>
                                   <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                   {item.name}
                               </label>
                           </div>
                       })}
                   </div>
               </Collapse>
           </div>
            <div className={'close-collapse'}>
                <div>
                    <h4>打球性質</h4>
                </div>
                    <div className='d-flex-align-center' style={{ display: "flex"}}>
                        {listHitting.map((item, index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                <label>
                                    <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                    {item.name}
                                </label>
                            </div>
                        })}
                    </div>
            </div>
        </div>
    )
}

export default HittingProperty;
